/**
 * Created by Christof Sander on 09.11.2016.
 */

module.exports = {
	hooks: {
		attach: function($element, options){
			console.log('ERROR', this.resourceData);
		}
	}
};
